<template>
  <div class="block">
    <el-pagination
        :current-page="current"
        :page-size="size"
        :pager-count="5"
        :total="total"
        background
        @size-change="sizeChange"
        @current-change="handleCurrent"
        @next-click="handleCurrent"
        @prev-click="handleCurrent"
    />
  </div>
</template>

<script>

export default {
  name: "Page",
  props: {
    current: Number,
    total: Number,
    size: Number
  },
  methods: {
    sizeChange(val) {
      this.$parent.size = val
      this.$parent.fetchData()
    },
    handleCurrent(val) {
      this.$parent.current = val
      this.$parent.fetchData()
    },
  },
}
</script>
